import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/')({
  beforeLoad: ({ context }) => {
    // Redirect logic will be handled after auth context is set up
    // For now, just redirect to dashboard
    throw redirect({ to: '/dashboard' })
  },
})
